import { commonTranslations } from './translations/common';
import { settingsTranslations } from './translations/settings';
import { clientsTranslations } from './translations/clients';
import { whatsappTranslations } from './translations/whatsapp';
import { dealsTranslations } from './translations/deals';
import { inventoryTranslations } from './translations/inventory';
import { documentsTranslations } from './translations/documents';
import { projectsTranslations } from './translations/projects';
import { ticketsTranslations } from './translations/tickets';
import { dashboardTranslations } from './translations/dashboard';
import { calendarTranslations } from './translations/calendar';
import { servicesTranslations } from './translations/services';
import { permissionsTranslations } from './translations/permissions';
import { authTranslations } from './translations/auth';

export const translations = {
  en: {
    common: commonTranslations.en,
    settings: settingsTranslations.en,
    clients: clientsTranslations.en,
    whatsapp: whatsappTranslations.en,
    deals: dealsTranslations.en,
    inventory: inventoryTranslations.en,
    documents: documentsTranslations.en,
    projects: projectsTranslations.en,
    tickets: ticketsTranslations.en,
    dashboard: dashboardTranslations.en,
    calendar: calendarTranslations.en,
    services: servicesTranslations.en,
    permissions: permissionsTranslations.en,
    auth: authTranslations.en
  },
  it: {
    common: commonTranslations.it,
    settings: settingsTranslations.it,
    clients: clientsTranslations.it,
    whatsapp: whatsappTranslations.it,
    deals: dealsTranslations.it,
    inventory: inventoryTranslations.it,
    documents: documentsTranslations.it,
    projects: projectsTranslations.it,
    tickets: ticketsTranslations.it,
    dashboard: dashboardTranslations.it,
    calendar: calendarTranslations.it,
    services: servicesTranslations.it,
    permissions: permissionsTranslations.it,
    auth: authTranslations.it
  }
};